import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { DateTime } from 'luxon';
import { Pill } from '@gtintel/platform-atoms';
import { NPRequestStatus } from '@gtintel/platform-types';
import { AssignmentDueColourMap, COLOURS, NPRequestStatusColourMap, formatDate, formatDateTime } from '@gtintel/platform-utils';
import { RequestEditorContext } from '../../ProjectApp/context';
export default () => {
  const ctx = useContext(RequestEditorContext);
  const [css] = useStyletron();
  if (!ctx) {
    return null;
  }
  const diff = DateTime.fromISO(ctx.dueDate()).diff(DateTime.now(), 'days').days;
  const day = Math.abs(Math.ceil(diff)) > 1 ? 'days' : 'day';
  let dueStatus;
  let dueText;
  if (diff > 6) {
    dueStatus = 'onTime';
    dueText = `Due in ${Math.ceil(diff)} ${day}`;
  } else if (diff === 0) {
    dueStatus = 'due';
    dueText = 'Due today';
  } else if (diff < 6 && diff > 0) {
    dueStatus = 'dueSoon';
    dueText = `Due in ${Math.ceil(diff)} ${day}`;
  } else {
    dueStatus = 'late';
    dueText = `${Math.ceil(Math.abs(diff))} ${day} late`;
  }
  return <div className={css({
    display: 'flex',
    flexFlow: 'row wrap',
    gap: '8px',
    marginBottom: '28px'
  })} data-testid="assignment-properties-card">
      <Pill colour={NPRequestStatusColourMap[ctx.status()]}>
        <strong>{NPRequestStatus[ctx.status()]}</strong>
      </Pill>
      <Pill colour={AssignmentDueColourMap[dueStatus]} title={dueText}>
        <strong>Due Date:</strong> {formatDate(ctx.dueDate())}
      </Pill>
      <Pill colour={COLOURS.blue}>
        <strong>Fee:</strong> {ctx.currency()}
        {ctx.fee()}
      </Pill>
      {ctx.acceptedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Accepted]}>
          <strong>Accepted Date:</strong> {formatDateTime(ctx.acceptedDate())}
        </Pill>}
      {ctx.activatedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Assigned]}>
          <strong>Activated Date:</strong> {formatDateTime(ctx.activatedDate())}
        </Pill>}
      {ctx.cancelledDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Cancelled]}>
          <strong>Cancelled Date:</strong> {formatDateTime(ctx.cancelledDate())}
        </Pill>}
      {ctx.declinedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Declined]}>
          <strong>Declined Date:</strong> {formatDateTime(ctx.declinedDate())}
        </Pill>}
      {ctx.submittedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Submitted]}>
          <strong>Submitted Date:</strong> {formatDateTime(ctx.submittedDate())}
        </Pill>}
      {ctx.finishedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Finished]}>
          <strong>Finished Date:</strong> {formatDateTime(ctx.finishedDate())}
        </Pill>}
    </div>;
};